<template>
    <div class="py-10 card-group" :class="backgroundClass">
        <plan-card
            ref="cards"
            @descHeightChanged="calcMaxDescHeight($event)"
            v-for="card in fields.planCards"
            :key="card.sys.id"
            :sys-id="card.sys.id"
            :descHeight="descHeight"
        />
    </div>
</template>

<script>
import PlanCard from './plan-card'
import { backgroundColorClass } from '../../../utils/helpers'

export default {
  name: 'PlanComparisonGroup',
  components: {
    PlanCard
  },
  props: {
    fields: {
      type: Object,
      required: true
    },
    sysId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      descHeight: null
    }
  },
  computed: {
    backgroundClass () {
      return backgroundColorClass(this.fields.background)
    }
  },
  methods: {
    /** Keeps all the cards blue description box the same height by setting them all to the height
     * of the tallest.
     * .If client decides they want all the cards to be the same size always, consider removing this and changing the cards to a css grid */
    calcMaxDescHeight (descHeight) {
      if (descHeight > this.descHeight) {
        this.descHeight = descHeight
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card-group {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
}
</style>
